import React from 'react';
import { useHistory } from 'react-router-dom';

import { Button, designTokens, Flex, Typography } from '@project44/manifest-ds';
import { useTranslation } from '@project44/translations-utils';

import Check from '../../resources/Check.svg';

const CreatePasswordSuccess = (): JSX.Element => {
  const { t } = useTranslation();

  const history = useHistory();

  return (
    <>
      <Typography
        variant="title"
        css={{
          color: designTokens.colorTextPrimary,
          marginBottom: designTokens.spaceMedium,
        }}
      >
        {t('setPasswordResponse.setPasswordSuccessHeader')}
      </Typography>
      <Flex
        css={{
          width: '100%',
          gap: designTokens.spaceSmall,
          padding: designTokens.spaceSmall,
          background: designTokens.colorBackgroundSuccess,
          alignItems: 'flex-start',
        }}
      >
        <img
          src={Check}
          style={{ position: 'relative', top: designTokens.spaceXSmall }}
          alt={t('setPasswordResponse.checkIcon')}
        />
        <Typography
          variant="subtext"
          css={{ color: designTokens.colorTextSuccess }}
        >
          {t('setPasswordResponse.setPasswordSuccess')}
        </Typography>
      </Flex>
      <Button
        variant="secondary"
        css={{ marginTop: designTokens.spaceMedium }}
        onClick={() => history.push('/login')}
      >
        {t('setPasswordResponse.signIn')}
      </Button>
    </>
  );
};

export default CreatePasswordSuccess;
